/**
 * @desc 获取验证码
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 用户编码 */
  code: string;
  /** 手机号码 */
  mobile: string;
}

export function request(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/web/user/getVerification',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/mock/web/user/getVerification',

    params,
  });
}
